import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useToast } from '../../../../../hooks/useToast';
import { templateKeys } from '../../../template-query-keys';
import { copyAutomationTemplate } from './copy-template-api';

export function useCopyTemplate() {
  const queryClient = useQueryClient();
  const { addToast } = useToast();

  return useMutation({
    mutationFn: (params: { sourceTemplateId: string; customName: string; customDescription: string }) =>
      copyAutomationTemplate(params.sourceTemplateId, {
        customName: params.customName,
        customDescription: params.customDescription,
      }),
    onSuccess: (result, variables) => {
      if (!result.created) {
        addToast({
          title: 'Template name already in use',
          description: 'A template with this name already exists. Please choose a different name.',
          variant: 'destructive',
        });
        return;
      } else {
        queryClient.invalidateQueries({ queryKey: templateKeys.lists() });
        addToast({
          title: 'Template copied',
          description: `Template "${variables.customName}" has been created.`,
          variant: 'default',
        });
      }
    },
    onError: (error: Error) => {
      addToast({
        title: 'Error copying template',
        description: error instanceof Error ? error.message : 'Please try again.',
        variant: 'destructive',
      });
    },
  });
}
